import angular from "angular";
import uiRouter from "angular-ui-router";
import routing from "./main.routes";
import addHtml from "./modal/add.html";

export class MainController {
  $http;
  socket;
  awesomeThings = [];
  awesomeUsers = [];
  newThing = "";

  /*@ngInject*/
  constructor(
    $http,
    $scope,
    socket,
    $uibModal,
    $cookies,
    $cookieStore,
    $location,
    $rootScope
  ) {
    this.$http = $http;
    this.socket = socket;
    this.$uibModal = $uibModal;
    this.$cookies = $cookies;
    this.$cookieStore = $cookieStore;
    this.$location = $location;
    this.$rootScope = $rootScope;

    $scope.$on("$destroy", function () {
      socket.unsyncUpdates("thing");
    });
  }

  $onInit() {
    if (this.$cookies.get("token")) {
      this.$location.path("user");
    }
  }

  login(form) {
    if (form.$valid === false) {
      return false;
    } else {
      this.$http.post("/api/backstages/", this.vm2).then(
        (response) => {
          if (response.status === 200) {
            let expireDate = new Date();
            expireDate.setTime(expireDate.getTime() + 30 * 24 * 60 * 60 * 1000); // cookies30天有效期
            this.$cookies.put("token", response.data.token, {
              expires: new Date(expireDate),
            });

            return this.$http
              .get("/api/backstages/me", {
                header: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  token: this.$cookies.get("token"),
                },
              })
              .then((data) => {
                if (data && data.data) {
                  if (data.data.role === "feedback") {
                    this.$location.path("feedback");
                    this.$rootScope.$emit("changeAccount");
                    return;
                  }
                }

                this.$location.path("user");
                this.$rootScope.$emit("changeAccount");
              });
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }
}

export default angular
  .module("tttApp.main", [uiRouter])
  .config(routing)
  .component("main", {
    template: require("./main.html"),
    controller: MainController,
  }).name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js